import React from "react";
import { Button } from "antd";
import { useIntl } from "react-intl";
import { Modal, Typography, Radio, Space } from "antd";
import {
  TotpMultiFactorGenerator,
  PhoneMultiFactorGenerator,
} from "firebase/auth";

const FactorsModal = (props) => {
  const { activeFactorId, visible, handleCancel, setActiveFactorId, onOk } =
    props;
  const intl = useIntl();
  const { Title, Text } = Typography;

  return (
    <Modal
      maskClosable={false}
      title={intl.formatMessage({
        id: "app.forms.user.2faFactorsTitle",
      })}
      centered
      onCancel={handleCancel}
      onOk={onOk}
      open={visible}
    >
      <p>
        {intl.formatMessage({
          id: "app.forms.user.2faFactorsSubTitle",
        })}
      </p>
      <Radio.Group onChange={setActiveFactorId} value={activeFactorId}>
        <Space direction="vertical">
          <Radio value={PhoneMultiFactorGenerator.FACTOR_ID}>
            <div>
              <Title level={5}>
                {intl.formatMessage({
                  id: "app.forms.user.2faFactorsSmsTitle",
                })}
              </Title>
              <Text>
                {intl.formatMessage({
                  id: "app.forms.user.2faFactorsSmsSubTitle",
                })}
              </Text>
            </div>
          </Radio>
          <Radio value={TotpMultiFactorGenerator.FACTOR_ID}>
            <div>
              <Title level={5}>
                {intl.formatMessage({
                  id: "app.forms.user.2faFactorsTotpTitle",
                })}
              </Title>
              <Text>
                {intl.formatMessage({
                  id: "app.forms.user.2faFactorsTotpSubTitle",
                })}
              </Text>
            </div>
          </Radio>
        </Space>
      </Radio.Group>
    </Modal>
  );
};

export default FactorsModal;
